export interface SmsConsentFieldErrors {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  terms?: string;
}

interface SmsConsentFormValues {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  acceptTerms: boolean;
}

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Minimum digits after stripping separators (typical national / E.164 local part length). */
const MIN_PHONE_DIGITS = 10;
const MAX_PHONE_DIGITS = 15;

export function validateSmsConsentForm(
  values: SmsConsentFormValues,
): SmsConsentFieldErrors {
  const errors: SmsConsentFieldErrors = {};

  const first = values.firstName.trim();
  if (!first) {
    errors.firstName = 'Please enter your name.';
  }

  const last = values.lastName.trim();
  if (!last) {
    errors.lastName = 'Please enter your last name.';
  }

  const digitsOnly = values.phoneNumber.replace(/\D/g, '');
  if (digitsOnly.length < MIN_PHONE_DIGITS) {
    errors.phoneNumber = 'Please enter a valid phone number (at least 10 digits).';
  } else if (digitsOnly.length > MAX_PHONE_DIGITS) {
    errors.phoneNumber = 'Please enter a valid phone number.';
  }

  const emailTrim = values.email.trim();
  if (!emailTrim) {
    errors.email = 'Please enter your email address.';
  } else if (!emailPattern.test(emailTrim)) {
    errors.email = 'Please enter a valid email address.';
  }

  if (!values.acceptTerms) {
    errors.terms = 'Please accept the Terms of Service and Privacy Policy to continue.';
  }

  return errors;
}
